import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class RoleService {
	baseUrl: string = environment.API_SERVER;
	constructor(private _http: HttpClient) {}
	getRoles(payload) {
		return this._http.get(`${this.baseUrl}/organizations/${payload.organizationId}/roles_aggregated/`, {
			params: payload.params
		});
	}
	addRoles(payload) {
		return this._http.post(`${this.baseUrl}/organizations/${payload.organizationId}/roles/`, payload.body);
	}
	deleteRole(payload) {
		return this._http.delete(`${this.baseUrl}/organizations/${payload.organizationId}/roles/${payload.roleName}/`);
	}

	getRolePermission(payload) {
		return this._http.get(
			`${this
				.baseUrl}/organizations/${payload.organizationId}/users/${payload.appUserId}/permissions/aggregate/roles/${payload.roleName}/permissions/`
		);
	}

  getRolePermission2(roleId: string) {
		return this._http.get(
			`${this.baseUrl}/organizations/roles/${roleId}/permissions/`
		);
	}

	updateRoles(payload) {
		return this._http.put(
			`${this.baseUrl}/organizations/${payload.organizationId}/roles/${payload.roleId}/`,
			payload.body
		);
	}

	assignRolePermission(payload) {
		return this._http.put(
			`${this.baseUrl}/organizations/${payload.organizationId}/roles/${payload.roleName}/permissions/`,
			payload.body
		);
	}
	removeRoles(payload) {
		return this._http.delete(
			`${this.baseUrl}/organizations/${payload.organizationId}/roles_aggregated/${payload.id}/`
		);
	}
}
